import {
  ButtonStyle,
  ModalConfirmComponent
} from './../../../../system/modal-confirm/modal-confirm.component';
import {
  ShareAccessPermission,
  SharedAcessActivity
} from './../../../../../models/shared-access-details';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChange,
  AfterViewInit,
  ElementRef,
  ViewContainerRef,
  ViewChild,
  AfterViewChecked,
  OnChanges,
  forwardRef,
  Inject,
  TemplateRef,
  HostListener
} from '@angular/core';
import { Activity, ActivityModel } from '../../../../../models/activities';
import { Role, Actions, WorkflowApplication } from '../../../../../models';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators
} from '@angular/forms';
import {
  WorkflowContextService,
  SecurityService,
  DataService
} from '../../../../../services';
import { from, Observable, OperatorFunction } from 'rxjs';
import { Router } from '@angular/router';
import {
  faShare,
  faShareAlt,
  faShareAltSquare
} from '@fortawesome/free-solid-svg-icons';
import { SharedAccessDetails } from 'src/app/models/shared-access-details';
import { SharePermissionsPipe } from 'src/app/pipes/share-permission.pipe';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { map } from 'lodash';
import { ActivityViewComponent } from '../activity-view/activity-view.component';
import { LayoutService } from 'src/app/services/layout.service';
import { UnsavedChangesService } from 'src/app/services/unsaved-changes.service';
import { Location } from '@angular/common';

enum SharingStatus {
  Loading,
  Loaded,
  Sharing,
  Shared
}
@Component({
  selector: 'wm-activity-container',
  templateUrl: './activity-container.component.html',
  styleUrls: ['./activity-container.component.css'],
  standalone: false
})
export class ActivityContainerComponent implements OnInit, OnChanges {
  @Input() activity: Activity<ActivityModel>;
  @Input() isPreview: boolean;
  @Input() isTestApplication: boolean;
  @Input() showTitle = true;
  @Output() value$: EventEmitter<any> = new EventEmitter<any>();
  @Output() saved: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelled: EventEmitter<any> = new EventEmitter<any>();
  @Output() committed: EventEmitter<any> = new EventEmitter<any>();
  @Output() goPrevious: EventEmitter<any> = new EventEmitter<any>();
  @Output() goNext: EventEmitter<any> = new EventEmitter<any>();
  @Output() switchApplication: EventEmitter<string> = new EventEmitter<
    string
  >();

  // Added by Amisha on 2026-07-09.
  // Reason: limit the browser-level unsaved-changes handling in this older
  // container to Janus flows so non-Janus screens keep their original behavior.
  private isJanusFlow(): boolean {
    return (
      this.context?.janusLayout === 'staff' ||
      this.context?.janusLayout === 'applicant'
    );
  }
  @Output() navigated: EventEmitter<string> = new EventEmitter<string>();
  @Output() onShouldShowNext: EventEmitter<boolean> = new EventEmitter<
    boolean
  >();
  @Output() onShouldShowPrevious: EventEmitter<boolean> = new EventEmitter<
    boolean
  >();
  @Output() onShouldShowCancel: EventEmitter<boolean> = new EventEmitter<
    boolean
  >();
  @Output() onShouldShowSave: EventEmitter<boolean> = new EventEmitter<
    boolean
  >();
  @Output() onReloadApp: EventEmitter<void> = new EventEmitter<void>();

  @Output() viewTitle$: EventEmitter<string> = new EventEmitter<string>();
  @Output() onViewDesigner: EventEmitter<
    Activity<ActivityModel>
  > = new EventEmitter();

  @Input() applicationId: string;
  @Input() role: Role;
  @Input() form: UntypedFormGroup;
  @ViewChild('shareApplicationAccess', { static: false })
  shareAccessModal: ModalConfirmComponent;
  @ViewChild('activityView', { static: false })
  activityViewCtl: ActivityViewComponent;

  faShare = faShareAlt;

  canViewComponent = true;
  canEditData = true;
  checkingPermissions = false;
  roleActionEntitled: { [key: string]: boolean } = {};
  //shouldShowCancel = true;
  //shouldShowSave = true;
  //shouldShowNext = true;
  //shouldShowPrevious = true;
  //canUseCancel = true;
  //canUseSave = true;
  //canUsePrevious = true;
  //canUseNext = true;
  isLastActivity = false;
  processing = false;
  viewTitle: string;
  sharingStatus: SharingStatus = SharingStatus.Loading;
  SharingStatus = SharingStatus;
  shareForm: UntypedFormGroup;
  showCommandButton = true;
  cancelText = 'Cancel';
  canViewDesign = false;
  //added by priya 2025-11-12
  templateForPermitForm = false;
  //end by priya 2025-11-12
  constructor(
    public layoutService: LayoutService,
    @Inject(forwardRef(() => WorkflowContextService))
    public context: WorkflowContextService,
    private _fb: UntypedFormBuilder,
    @Inject(forwardRef(() => SecurityService))
    private _securitySvc: SecurityService, // , private _el: ElementRef
    private _router: Router,
    @Inject(forwardRef(() => DataService)) private _ds: DataService,
    private unsavedChangesService: UnsavedChangesService, // Code added by Sanchit on 03/06/2026
    private location: Location // Code added by Sanchit on 03/06/2026
  ) {
    //added by priya 2025-11-12
    const nav = this._router.getCurrentNavigation();
    const navState = nav?.extras?.state as { useNewLayout?: boolean };
    layoutService.useNewLayout$.subscribe(useNewLayout => {
      this.templateForPermitForm = useNewLayout;
    });
    //end by priya 2025-11-12
  }

  // Start Code added by Sanchit on 03/06/2026
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: BeforeUnloadEvent): void {
    // Added by Amisha on 2026-07-09.
    // Reason: the browser refresh/close warning should only be active for the
    // Janus experience that uses the shared AppView leave-confirmation flow.
    if (!this.isJanusFlow()) {
      return;
    }

    if (!this.unsavedChangesService.canLeave()) {
      $event.preventDefault();
      $event.returnValue = '';
    }
  }

  // @HostListener('window:popstate', ['$event'])
  // onPopState(event: PopStateEvent) {
  //   if (this.unsavedChangesService.hasUnsavedChanges) {
  //     const leave = confirm(
  //       'Changes you made may not be saved.'
  //     );

  //     if (!leave) {
  //       history.pushState(null, '', location.href);
  //     }
  //   }
  // }
  // End Code added by Sanchit on 03/06/2026

  get activityViewLoaded(): boolean {
    return this.activityViewCtl != null && this.activityViewCtl.instanceLoaded;
  }

  ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    if (changes['role']) {
      this.canView();
    }
  }

  canView() {
    const self = this;

    self.roleActionEntitled = {};
  }
  getDesignButtonData = (
    template: TemplateRef<any>,
    activity: Activity<ActivityModel>
  ) => {
    return {
      text: template,
      onClick: () => {
        if (this.canViewDesign) {
          this.openWorkflowDesign(activity);
        }
      }
    };
  };
  cancel() {
    this._ds.cancelApplications(this.context.applicationId).subscribe(o => {
      if (o) {
        this._router.navigate(['/', 'home']).then(
          nav => {},
          err => {
            console.error(err); // when there's an error
          }
        );
      }
    });
  }
  showNextChanged(e) {
    this.onShouldShowNext.emit(e);
  }
  navigate(activityId: string) {
    this.processing = true;
    this.navigated.emit(activityId);
  }
  next() {
    this.processing = true;
    this.committed.emit(this.activity);
  }
  async persistChildComponent() {
    return this.activityViewCtl.persistChildComponent();
  }

  save() {
    this.saved.emit(this.activity);
  }

  previous() {
    this.processing = true;
    this.goPrevious.emit(this.activity);
  }

  async ngOnInit() {
    this.unsavedChangesService.setUnsavedChanges(true); // Code added by Sanchit on 03/06/2026
    // Added by Amisha on 2026-07-09.
    // Reason: only Janus flows should push browser history state for the back
    // button warning; non-Janus flows were being affected unnecessarily.
    if (this.isJanusFlow()) {
      history.pushState(null, '', location.href); // Code added by Sanchit on 03/06/2026
    }
    //added by priya 2025-11-04
    if (!this.form) {
      this.form = new UntypedFormGroup({});
    }
    //end by priya
    this.canViewDesign = await this._securitySvc
      .isLoginEntitled(Actions.DO_ANYTHING)
      .toPromise();
  }

  setViewTitle(e: string) {
    this.viewTitle$.next(e);
    this.viewTitle = e;
  }

  details: SharedAccessDetails = null;
  ButtonStyle = ButtonStyle;

  filteredPriorActivities: SharedAcessActivity[];
  filteredFutureActivities: SharedAcessActivity[];
  activitySearchQuery: string = '';
  activitySearchFieldConfig = {
    label: 'Search activities...'
  };
  handleActivitiesSearchChange(value: string): void {
    this.activitySearchQuery = value;

    // const text = e.srcElement.value.toLowerCase();

    if (this.activitySearchQuery) {
      const futureSrc =
        this.filteredFutureActivities.length > 0
          ? this.filteredFutureActivities
          : this.details.futureActivities;
      const priorSrc =
        this.filteredFutureActivities.length > 0
          ? this.filteredPriorActivities
          : this.details.priorActivities;

      this.filteredFutureActivities = futureSrc.filter(
        a => a.activityName.toLowerCase().indexOf(this.activitySearchQuery) > -1
      );
      this.filteredPriorActivities = priorSrc.filter(
        a => a.activityName.toLowerCase().indexOf(this.activitySearchQuery) > -1
      );
    } else {
      this.filteredFutureActivities = this.details.futureActivities;
      this.filteredPriorActivities = this.details.priorActivities;
    }
  }

  searchActivities(e: any) {
    const text = e.srcElement.value.toLowerCase();

    if (text) {
      const futureSrc =
        this.filteredFutureActivities.length > 0
          ? this.filteredFutureActivities
          : this.details.futureActivities;
      const priorSrc =
        this.filteredFutureActivities.length > 0
          ? this.filteredPriorActivities
          : this.details.priorActivities;

      this.filteredFutureActivities = futureSrc.filter(
        a => a.activityName.toLowerCase().indexOf(text) > -1
      );
      this.filteredPriorActivities = priorSrc.filter(
        a => a.activityName.toLowerCase().indexOf(text) > -1
      );
    } else {
      this.filteredFutureActivities = this.details.futureActivities;
      this.filteredPriorActivities = this.details.priorActivities;
    }
  }

  getShareApplicationDetails() {
    this.shareForm = new UntypedFormGroup({
      emailAddress: new UntypedFormControl('', [
        Validators.required,
        Validators.email
      ]),
      loaded: new UntypedFormControl('', Validators.required)
    });

    this.cancelText = 'Cancel';
    this.showCommandButton = true;

    this.sharingStatus = SharingStatus.Loading;
    this._ds
      .getWorkflowApplicationShareDetails(this.applicationId, this.activity)
      .subscribe(details => {
        this.sharingStatus = SharingStatus.Loaded;
        if (details.futureActivities) {
          details.futureActivities = details.futureActivities.filter(a =>
            this.canShareView(a)
          );
          this.filteredFutureActivities = details.futureActivities;
        }
        if (details.priorActivities) {
          details.priorActivities = details.priorActivities.filter(a =>
            this.canShareView(a)
          );
          this.filteredPriorActivities = details.priorActivities;
        }

        this.details = details;
        this.shareForm.controls['loaded'].setValue('true');
      });
  }

  showActivities(share: SharedAccessDetails): boolean {
    share.showDetails = !share.showDetails;
    if (!share.activities) {
      this._ds.getShareActivities(share.id).subscribe(activities => {
        share.activities = activities || [];
      });
    }
    return false;
  }

  removeSharedAccess(e: string) {
    this._ds.revokeSharedAccess(e).subscribe(() => {
      this.details.shares = this.details.shares.filter(s => s.id !== e);
    });
  }

  shareApplication() {
    this.sharingStatus = SharingStatus.Sharing;

    // Start Code added by Sanchit on 29/05/2026
    requestAnimationFrame(() => {
      const header = document.querySelector('.header-parent-container') as HTMLElement;
      header?.style.setProperty('z-index', '1', 'important');
    });
    // End Code added by Sanchit on 29/05/2026

    this._ds.shareWorkflowApplication(this.details).subscribe(() => {
      this.sharingStatus = SharingStatus.Shared;
      this.showCommandButton = false;
      this.cancelText = 'Close';

      // added by furkan for fixing share modal stuck after shared
      if (this.shareAccessModal) {
        this.shareAccessModal.processing = false;
      }
    });
  }

  canShareView(a: SharedAcessActivity) {
    return a.availablePermissions.indexOf(ShareAccessPermission.ReadOnly) > -1;
  }

  canEdit(a: SharedAcessActivity) {
    return a.availablePermissions.indexOf(ShareAccessPermission.Edit) > -1;
  }

  openWorkflowDesign(activity: Activity<ActivityModel>) {
    this.onViewDesigner.emit(activity);
  }

  reloadApp() {
    this.onReloadApp.emit();
  }
  getSharedButtonData = (template: TemplateRef<any>) => {
    return {
      text: template,
      onClick: () => {
        this.shareAccessModal.open();
      }
    };
  };
}
